import { createSlice } from '@reduxjs/toolkit';
import { RootState } from '../store/Store';
import { IUserResponseDto } from './Profile.model';
import {profileApi} from './Profile.api'

type InitialState = {
  user: IUserResponseDto | undefined
}

const initialState = {
  user: undefined,
} as InitialState;

export const profileSlice = createSlice({
  name: 'profile',
  initialState,
  reducers: {
    // fetchUser(state) {
    //   state = initialState;
    // },
  },
  extraReducers(builder) {
    builder
      .addMatcher(profileApi.endpoints.getUserById.matchFulfilled, (state, action) => {
        state.user = action.payload
      })
      .addMatcher(profileApi.endpoints.getUserById.matchRejected, (state, action) => {
        state = initialState
      })
  },
});

export const {} = profileSlice.actions
export default profileSlice.reducer
export const selectUser = (state: RootState) => state.profileReducer.user
